module.exports = __webpack_public_path__ + "img/ninos.ec412d8f.svg";